import { Children, type ReactNode, type ReactElement } from "react";

import Styles from "./index.module.scss";

type SectionTitleProps = {
  title?: ReactNode;
};

type SectionProps = SectionTitleProps & {
  children: ReactNode;
};

export function SectionTitle({ title }: SectionTitleProps) {
  return <h3 className={Styles.title}>{title}</h3>;
}

export function Section({ children, title }: SectionProps) {
  return (
    <div className={Styles.section}>
      {title && <SectionTitle title={title} />}
      <div className={Styles.grid}>{children}</div>
    </div>
  );
}

function isCompleteChild(child: ReactNode): boolean {
  return Boolean(!child || (child as ReactElement<{ complete?: boolean }>).props.complete);
}

export function TaskSection(props: SectionProps) {
  const completeChildren: boolean[] = Children.map(props.children, isCompleteChild) || [];
  return completeChildren.every(Boolean) ? null : <Section {...props} />;
}
